import { Alert, Dialog, Paragraph } from "@fronterahealth/frontera-ui-components";

interface ConfirmDeleteAiFieldDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  fieldTitle: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

export const ConfirmDeleteAiFieldDialog: React.FC<ConfirmDeleteAiFieldDialogProps> = ({
  open,
  setOpen,
  fieldTitle,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      title="Remove AI Field?"
      open={open}
      setOpen={setOpen}
      primaryButton={{
        text: "Remove Field",
        onClick: onConfirm,
        buttonAction: "destructive",
      }}
      secondaryButton={{
        text: "Cancel",
        onClick: onCancel,
      }}
      size="2xl"
    >
      <Paragraph className="mb-4" displayType="normal" colorType="primary">
        <strong>&ldquo;{fieldTitle}&rdquo;</strong> is an AI-generated field with a specialized prompt that cannot be
        recreated manually. Once deleted, this field and its AI configuration will be permanently lost.
      </Paragraph>
      <Alert
        title=""
        text={
          <p className="-mt-2">
            If you&apos;re unsure, consider moving this field to a different section instead of deleting it.
          </p>
        }
        appearance="neutral"
      />
    </Dialog>
  );
};
